<script lang="ts">
  import CheckboxIcon from '$icons/CheckboxIcon.svelte';
  import CornerIcon from '$icons/CornerIcon.svelte';
  import ErrorWarningAlertIcon from '$icons/ErrorWarningAlertIcon.svelte';
  import InfoSquareIcon from '$icons/InfoSquareIcon.svelte';
  import XIcon from '$icons/XIcon.svelte';
  import { onMount } from 'svelte';

  export let positive = false;
  export let warning = false;
  export let negative = false;
  export let informational = false;
  export let gray = false;
  export let title = '';
  export let description = '';
  export let noIcon = false;
  export let contentFit = false;
  export let dismissAbleStorageKey = '';

  let buttonContainer: HTMLDivElement;
  // biome-ignore lint/suspicious/noExplicitAny: TODO: Fix this missing type
  export let icon: any = null;
  $: {
    if (icon == null) {
      if (positive) icon = CheckboxIcon;
      else if (warning || negative) icon = ErrorWarningAlertIcon;
      else icon = InfoSquareIcon;
    }
  }

  let isVisible = !dismissAbleStorageKey;

  onMount(() => {
    if (dismissAbleStorageKey) {
      const dismissed = localStorage.getItem(dismissAbleStorageKey);
      if (dismissed !== 'true') {
        isVisible = true;
      }
    }
  });

  function dismissNotification() {
    isVisible = false;
    if (dismissAbleStorageKey) {
      localStorage.setItem(dismissAbleStorageKey, 'true');
    }
  }
</script>

{#if isVisible}
  <div
    class:positive
    class:warning
    class:negative
    class:informational
    class:gray
    class="border-gray-dark-8 bg-gray-dark-0 p-3xs relative border {contentFit
      ? 'w-fit'
      : 'w-80'} {$$props.class}"
  >
    <CornerIcon class="-m-3xs text-gray-dark-12 absolute right-0 top-0" />
    <CornerIcon class="-m-3xs text-gray-dark-12 absolute bottom-0 left-0 rotate-180" />
    {#if dismissAbleStorageKey}
      <button
        on:click={dismissNotification}
        class="text-gray-dark-11 hover:text-gray-dark-12 absolute right-2 top-2"
      >
        <XIcon class="h-4 w-4" />
      </button>
    {/if}
    <div class="inner-container p-md w-full border">
      <div class="content-wrapper">
        {#if !noIcon}
          <div class="icon-wrapper {title ? 'top-0' : '-top-1'}">
            <svelte:component
              this={icon}
              class="{positive
                ? 'text-mint-dark-11'
                : informational
                  ? 'icon text-indigo-dark-11'
                  : warning
                    ? 'text-orange-dark-11'
                    : negative
                      ? 'text-red-dark-11'
                      : 'text-gray-dark-12'} h-6 w-6"
            />
          </div>
        {/if}
        <div class="text-wrapper">
          <h2 class="title">{title}</h2>
          {#if description}
            <p class="description whitespace-pre-line">
              {@html description}
            </p>
          {/if}
        </div>
      </div>

      <div
        bind:this={buttonContainer}
        class="gap-x-md flex w-full items-center justify-between {buttonContainer?.hasChildNodes()
          ? 'mt-md'
          : 'mb-0'}"
      >
        <slot />
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  .title {
    @apply font-architekt text-gray-dark-12 text-sm font-normal leading-6;
  }
  .description {
    @apply mt-2xs text-gray-dark-11 text-xs font-normal leading-4;
  }
  .inner-container {
    @apply border-gray-dark-4 bg-gray-dark-2;
  }
  .positive {
    @apply border-mint-dark-11;
  }
  .positive > .inner-container {
    @apply border-mint-dark-4 bg-mint-dark-2;
  }
  .warning {
    @apply border-orange-dark-11;
  }
  .warning > .inner-container {
    @apply border-orange-dark-4 bg-orange-dark-2;
  }

  .negative {
    @apply border-red-dark-11;
  }
  .negative > .inner-container {
    @apply border-red-dark-4 bg-red-dark-2;
  }
  .informational {
    @apply border-indigo-dark-11;
  }
  .informational > .inner-container {
    @apply border-indigo-dark-4 bg-indigo-dark-2;
  }

  .informational.gray {
    @apply border-gray-dark-8;
  }
  .informational.gray > .inner-container {
    @apply border-gray-dark-4 bg-gray-dark-2;
  }

  .content-wrapper {
    @apply relative;
    min-height: 1.5rem;
  }

  .icon-wrapper {
    @apply absolute left-0;
  }

  .text-wrapper {
    @apply pl-8;
  }
</style>
